/* stylelint-disable selector-max-compound-selectors, max-nesting-depth */

:host {
    @include typo-ws-paragraph;

    display: block;

    slot[name='text'] {
        display: block;
        margin: 4px 0 0 24px;
    }
}

@include mq-1 {
    :host {
        @include typo-ws-paragraph-s;
    }
}
